import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import type { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Feedback } from '../models/feedback.model';

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {
  private http = inject(HttpClient);

  public sendFeedback(feedback: Feedback): Observable<any> {
    return this.http.post<any>(`${environment.beBaseURL}/api/feedback`, feedback);
  }
}
